import { Component } from '@angular/core';
import { ParamsModel } from '../match-details/models/params.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatchDataService } from '../match-details/services/match-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-live-tracker',
  standalone: true,
  imports: [],
  templateUrl: './live-tracker.component.html',
  styleUrl: './live-tracker.component.scss'
})
export class LiveTrackerComponent {

  params: ParamsModel = {} as ParamsModel;
  linkLiveTracker: SafeResourceUrl = '';

  constructor(
    private readonly matchService: MatchDataService,
    private sanitizer: DomSanitizer,
    private readonly _activateRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._activateRoute.params.subscribe((params: any) => {
      this.params = params;
      this.getLinkTracker();
    });
  }

  private getLinkTracker() {
    this.linkLiveTracker = this.sanitizer.bypassSecurityTrustResourceUrl(this.matchService.getUrlMatchTracker(this.params));
  }

}
